
import React from 'react';
import './Home.css';

function Welcome() {


    const homeRoute = () => {
        window.location.href = '/home';
    }




    return (
        <div className="feedback-container">
         
                  
                    <button>
                    <a className='feedback' href="https://feedback.procuratio.com/dynamic/61af1a1453720901f399199a">Feedback</a>
                </button>
             
    

        </div>




    )
}

export default Welcome;


